<template>
  <el-dialog
    :visible.sync="dialogVisible"
    @open="openDialog"
    top="7vh"
  >
  <!-- :title:title -->
    <div slot="title" class="dia-tit">
      <i></i>
      <span>备课开关</span>
    </div>
    <el-tree
      :data="treeList"
      show-checkbox
      ref="eltreeData"
      node-key="id"
      :default-expand-all="true"
      :default-checked-keys="checkedArray"
      :props="defaultProps">
      <!-- :default-checked-keys 设置默认选中的节点  default-expand-all 默认展开所有节点 :expand-on-click-node="false" 只有点击三角形的时候才会展开或者关闭，点击节点无效 :current-node-key 默认选中的节点 highlight-current 节点高亮（据说这个要后面防止默认节点不高亮） @node-click=点击节点-->
    </el-tree>
    <el-row slot="footer">
      <el-button type="primary" size="small" @click="saveForm" class="dialog-btn">保 存</el-button>
      <el-button @click="close" size="small" type="info" class="dialog-btn">取 消</el-button>
    </el-row>
  </el-dialog>
</template>
<script>
import {
  $getMerchantList,
  $addCoursePreparationUser,
} from "@/apiteacher/teacher";
export default {
  props: {
    title: { type: String, default: "" },
    courseUnitId: {
      type: String,
      default: ()=>{},
    }
  },
  data() {
    return {
      checkedArray:[],
      dialogVisible: false,
      currentId: "",
      treeList: [],
      defaultProps: {
        children: "employees",
        label: "name",
      },
      deId: [],
    };
  },

  methods: {
    openDialog() {
      this.treeList = []
      this.getMerchantList()
    },
    // 获取全部商户老师列表
    async getMerchantList () {
      const res = await $getMerchantList({courseUnitId:this.courseUnitId})
      this.treeList = res.body.list
      this.checkedArray = []
      this.treeList.forEach(item => {
        item.employees.forEach(value => {
          if(value.ifAdded === '1') {
            this.checkedArray.push(value.id)
          }
        })
      })
    },
    async saveForm () {
      let thembArray = this.$refs.eltreeData.getCheckedNodes()
      let courseList = []
      if(thembArray.length === 0) {
        let object = {
          courseUnitId:this.courseUnitId
        }
        courseList.push(object)
      }else {
        thembArray.forEach(item => {
          if(item.ifAdded !== undefined && item.ifAdded !== null) {
            let object = {}
            object.courseUnitId = this.courseUnitId
            object.userId = item.id
            courseList.push(object)
          }
        })
      }

      if(courseList.length === 0) {
        let object = {
          courseUnitId:this.courseUnitId
        }
        courseList.push(object)
      }
      let responseData = await $addCoursePreparationUser(
        JSON.stringify(courseList)
      );

      if (responseData && responseData.state == "success") {
        window.$msg('保存成功')
        this.getMerchantList()
      }
    },
    close () {
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.el-form .el-form-item {
  margin-bottom: 30px;
}
// @import "~@/style/dialog.scss";
@import "../../style/dialog.scss";
/deep/ .el-tree-node__label {
  margin-left: 10px;
}
</style>
